import React, { useRef, useState } from 'react';
import MaskedInput from 'react-maskedinput';
import { Typography } from '../../components/Typography';
import { Icon } from '../../components/Icon';
import { useTheme } from 'react-jss';
import { useStyles } from './styles';
import clsx from 'clsx';
import { Icons } from '../../types/icons';
const TextInputTypes = {
    TEXT: 'text',
    PASSWORD: 'password',
    EMAIL: 'email',
    TEL: 'tel',
    NUMBER: 'number',
    DATE: 'date',
    FILE: 'file',
    TIME: 'time',
    URL: 'url',
};
const TextInput = ({ autofocus = false, canPaste = true, disabled = false, errorOnTop = false, hasError = false, icon, inputHeight, mask = '', maxLength, messageError = '', name = '', onClickIcon, onFocusOut, onInputChange, onKeyDown, onKeyPress, placeholder = '', readOnly = false, required = false, size, type = TextInputTypes.TEXT, value, }) => {
    const InputTag = mask ? MaskedInput : 'input';
    const isPassword = type === TextInputTypes.PASSWORD;
    const theme = useTheme();
    const inputElement = useRef();
    const styles = useStyles({ theme });
    const [showPassword, setShowPassword] = useState(false);
    const inputStyle = clsx({
        [styles.input]: true,
        [styles.inputError]: hasError,
        [styles.inputPassword]: isPassword && !showPassword,
        [styles.inputIcon]: !!icon || isPassword,
    });
    const getKeyboardType = () => {
        if (isPassword)
            return showPassword ? TextInputTypes.TEXT : TextInputTypes.PASSWORD;
        // Somente números com base na máscara informada (ex: mask=111.111.11)
        // Nota: type TEL ao invés de NUMBER devido a limitação do react-maskedinput
        if (mask && mask.includes('1') && !mask.includes('a') && !mask.includes('A') && !mask.includes('*') && !mask.includes('#'))
            return TextInputTypes.TEL;
        return type;
    };
    const getIconName = () => {
        if (isPassword) {
            return showPassword ? Icons.MicrophoneOn : Icons.MicrophoneOff;
        }
        else {
            return icon;
        }
    };
    const onShowPassword = () => {
        setShowPassword(!showPassword);
        inputElement.current.focus();
    };
    const onPaste = (e) => {
        if (!canPaste)
            e.preventDefault();
        return canPaste;
    };
    return (React.createElement("div", { className: styles.container },
        hasError && errorOnTop &&
            React.createElement(Typography, { variant: "content3", color: "danger", customClassName: styles.topError }, messageError),
        React.createElement("div", { className: styles.content },
            React.createElement(InputTag, { ref: inputElement, autoComplete: "off", autoFocus: autofocus, className: inputStyle, disabled: disabled, id: name, mask: mask ? mask : '', maxLength: maxLength, name: name, onBlur: onFocusOut, onChange: onInputChange, onDrop: (e) => onPaste(e), onDropCapture: (e) => onPaste(e), onKeyDown: onKeyDown, onKeyPress: onKeyPress, onPaste: (e) => onPaste(e), onPasteCapture: (e) => onPaste(e), placeholder: placeholder, readOnly: readOnly, required: required, size: size, style: inputHeight && { 'height': inputHeight }, type: getKeyboardType(), value: value }),
            !!icon || isPassword ? (React.createElement(Icon, { height: "24", width: "24", name: getIconName(), color: theme.palette.primary.regular, customClassName: styles.iconButton, onClick: isPassword ? onShowPassword : onClickIcon })) : null),
        hasError && !errorOnTop &&
            React.createElement(Typography, { variant: "content3", color: "danger", customClassName: styles.bottomError }, messageError)));
};
export { TextInput, TextInputTypes };
//# sourceMappingURL=TextInput.js.map